import * as React from "react";
import { UserProvider } from "@linkfluence/core/user/context";
import Loading from "@ui-kit/splash-screen";
import { useBootstrapUser } from "@kol/core/user/use-cases/useBootstrapUser";

export default function UserConnectedPage({
  children,
}: {
  children: React.ReactNode;
}) {
  const { loading, user } = useBootstrapUser();
  return (
    <UserProvider user={user}>{loading ? <Loading /> : children}</UserProvider>
  );
}
